import { render, staticRenderFns } from "./ViewDocument.vue?vue&type=template&id=226fc91c&scoped=true&"
import script from "./ViewDocument.ts?vue&type=script&lang=ts&"
export * from "./ViewDocument.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226fc91c",
  null
  
)

export default component.exports